import { useState, useEffect } from "react";
import {
  getTranscriptsByID,
  getTranscriptionFinal,
  uploadTranscriptionToS3,
} from "../../services/transcript.service";
import Button from "../button/button";

const ListTranscript = ({ id }) => {
  const [transcripts, setTranscripts] = useState([]);
  const [transcription, setTranscription] = useState([]);
  const [audioUrlGet, setAudioUrlGet] = useState("");

  const [editingIndex, setEditingIndex] = useState(null);
  const [editedTranscript, setEditedTranscript] = useState("");

  const getAllTranscriptsByID = async () => {
    try {
      const response = await getTranscriptsByID(id);
      setTranscripts(response);
      console.log("Transcripts:", response);
    } catch (err) {
      console.error("Error fetching transcripts:", err);
    }
  };

  useEffect(() => {
    getAllTranscriptsByID();
    // eslint-disable-next-line
  }, [id]);

  const formattedTranscripts = (transcript) => {
    // eslint-disable-next-line
    const match = transcript.match(/\/([^\/]+)-[^-]+/);
    return match ? match[1] : transcript;
  };

  const getFinalTranscription = async (audioUrl) => {
    try {
      const response = await getTranscriptionFinal(audioUrl);
      console.log("Transcription:", response);
      setTranscription(response);
      setAudioUrlGet(audioUrl);
    } catch (err) {
      console.error("Error fetching transcription:", err);
    }
    setEditingIndex(null);
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditedTranscript(transcription[index]);
  };

  const handleEditedTranscriptChange = (event) => {
    setEditedTranscript(event.target.value);
  };

  const saveEditedTranscript = (transcriptionURL) => {
    if (editingIndex !== null) {
      const updatedTranscription = [...transcription];
      updatedTranscription[editingIndex] = editedTranscript;
      setTranscription(updatedTranscription);

      uploadTranscriptionToS3(transcriptionURL, updatedTranscription);

      setEditingIndex(null);
      setEditedTranscript("");
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-center w-full mb-4">
        <h3 className="text-white">Lista de Transcripciones</h3>
      </div>
      <div className="flex w-full gap-3">
        <div className="w-[30%] max-h-[80vh] overflow-y-auto">
          {transcripts.map((transcript) => (
            <div
              key={transcript}
              className="bg-gray-800 text-white p-4 mb-2 rounded-lg shadow-lg border-2 border-white cursor-pointer"
              onClick={() => getFinalTranscription(transcript)}
            >
              <p>{formattedTranscripts(transcript)}</p>
            </div>
          ))}
        </div>

        <div className="w-[70%] max-h-[80vh] overflow-y-auto border-2 border-white ml-4 rounded-lg">
          {transcription.map((transcript, index) => (
            <div className="mt-5 flex justify-between items-start" key={index + "t"}>
              <div className="flex items-start w-full">
                {editingIndex === index ? (
                  <div className="w-full mx-4">
                    <textarea
                      value={editedTranscript}
                      onChange={handleEditedTranscriptChange}
                      className="bg-transparent text-white p-4 rounded-lg w-full border border-transparent focus:border-blue-500"
                    />
                  </div>
                ) : (
                  <p className="text-white px-8 text-lg" key={index}>
                    {transcript}
                  </p>
                )}
              </div>

              <div className="flex items-start">
                {editingIndex === index ? (
                  <Button
                    onClick={() => saveEditedTranscript(audioUrlGet)}
                    label={"Guardar"}
                    variant={"primary"}
                    customClassName="mr-5"
                    key={"edit " + index}
                  />
                ) : (
                  <Button
                    onClick={() => startEditing(index)}
                    label={"Editar"}
                    variant={"primary"}
                    customClassName="mr-5"
                    key={"save " + index}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListTranscript;
